/**
 * Splits a plain text string on line breaks and renders each non-empty line
 * as its own <p> element, preserving the paragraph formatting the user
 * typed in the admin panel (multiple lines / paragraphs).
 *
 * Accepts either a string (splits on \n / \r\n) or an array of lines
 * (as used by services.homeBody).
 *
 * @param {object} props
 * @param {string|string[]} props.text
 * @param {string} [props.className]      Classes applied to EACH <p>.
 * @param {string} [props.wrapperClassName] Classes applied to the container <div>.
 * @param {string} [props.spacingClass="mb-3 last:mb-0"] Bottom margin between paragraphs.
 * @param {string} [props.testId]
 */
export function Paragraphs({
  text,
  className = '',
  wrapperClassName = '',
  spacingClass = 'mb-3 last:mb-0',
  testId,
}) {
  const lines = Array.isArray(text)
    ? text
    : (text || '').split(/\r?\n/);

  const paragraphs = lines
    .map((l) => (typeof l === 'string' ? l : ''))
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  if (paragraphs.length === 0) return null;

  return (
    <div className={wrapperClassName} data-testid={testId}>
      {paragraphs.map((line, i) => (
        <p key={i} className={`${spacingClass} ${className}`.trim()}>
          {line}
        </p>
      ))}
    </div>
  );
}
